import React from 'react';
import Table from "../../../common/table/table";
import ShopTimeEntrySummaryTable from "./shopTimeEntrySummaryTable.js";
import MessageEmptyData from "../../../common/messageEmptyData";

/**
 * ShopTimeEntryReviewBody component
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ShopTimeEntrySummaryBody = (prop) => {
    const {filters, tableData} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <Table
                columns={ShopTimeEntrySummaryTable()}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'shop_time_entry_summary'}
                withGlobalSearch={true}
                scrollable={true}
            />
        </div>
    );
}

export default ShopTimeEntrySummaryBody;
